import { StatusDto } from '@/api/ApiClient';
import type { NodeType } from '@/types/tree/base';
import {
  nodeTypeToFileParentKind,
  parentStatusAllowsFileMutation,
} from '@/types/tree/actions/fileMutationStatusPolicy';

/**
 * Upload disabled state for the Files tab: parent privilege + parent status policy + file create.
 */
export function isFilesUploadDisabled(params: {
  nodeType: NodeType;
  nodeStatus?: string;
  isReadOnlyNode: boolean;
  canCreateFile: boolean;
  canMutateFilesOnParent: boolean;
}): boolean {
  const { nodeType, nodeStatus, isReadOnlyNode, canCreateFile, canMutateFilesOnParent } = params;

  if (isReadOnlyNode || !canCreateFile || !canMutateFilesOnParent) {
    return true;
  }

  const parentKind = nodeTypeToFileParentKind(nodeType);
  if (parentKind != null && !parentStatusAllowsFileMutation(parentKind, nodeStatus)) {
    return true;
  }

  return nodeStatus === StatusDto.Published;
}
